// @flow
import ReactLoadableLoader from './ReactLoadableLoader'
export default ReactLoadableLoader
